/* eslint max-classes-per-file: 0 */

import {
  Mark as Data,
  MarkCollection as Collection,
} from '@/typings/api/Marks'

import { BaseMarksApiAuth } from '@/api/BaseApiAuth'
import { BaseApiResponse } from '@/typings/common'
import { AxiosRequestConfig } from 'axios'

export class TasksOrderApi extends BaseMarksApiAuth<Data, Collection> {
  protected readonly endpoint = 'tasks_order';

  protected readonly hasFinishSlash = false;

  public parse(body: { procedure_id: string }, config?: AxiosRequestConfig) {
    const path = 'parse'
    const [url] = this.getUrl(path)
    return this.request<never, BaseApiResponse<Data, Collection>>(
      'POST',
      url,
      { data: body, ...config },
    )
  }
}
